const getRangeKeysForType = (type) => {
  switch (type) {
    case 'First Fitting':
      return ['firstAlterationStart', 'firstAlterationEnd'];
    case 'Second Fitting':
      return ['secondAlterationStart', 'secondAlterationEnd'];
    case 'Third Fitting':
      return ['thirdAlterationStart', 'thirdAlterationEnd'];
    default:
      return [];
  }
};

export default getRangeKeysForType;